import { render, staticRenderFns } from "./BaseSideBar.vue?vue&type=template&id=3806b471&scoped=true&"
import script from "./BaseSideBar.vue?vue&type=script&lang=ts&"
export * from "./BaseSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSideBar.vue?vue&type=style&index=0&id=3806b471&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806b471",
  null
  
)

export default component.exports